import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import '../../bins/parts/bin-profile-svg';

class DeviceMonitoringChartBinProfile extends LitEntity {
  constructor() {
    super();
    this.padding = 3;
  }

  static get properties() {
    return {
      height: { type: Number },
      width: { type: Number },
      padding: { type: Number },
      level: { type: Object },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host{
        display: inline-block;
        position: relative;
        height: 100%;
        width: 100%;
      }
      .no-data {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        background-color: var(--blue-40);
        box-sizing: border-box;
        box-shadow: inset 0 0 3px var(--blue-50);
        color: var(--blue-50);
      }
      .no-data bn-icon {
        font-size: 1.5em;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`
        <div class="no-data">
          <bn-icon name="fas fa-spinner fa-pulse"></bn-icon>
        </div>
      `;
    }

    return html`
      <bin-profile-svg
        .binvolumes="${this.getProperty('volumes')}"
        .bindimensions="${this.getProperty('dimensions')}"
        .binlevel="${this.level}"
        .padding="${this.padding}"
      ></bin-profile-svg>
    `;
  }
}

window.customElements.define('device-monitoring-chart-bin-profile', DeviceMonitoringChartBinProfile);
